export default {
  oidc: {
    clientId: '0oa21w4pw8HjPbBBA2p7',
    issuer: 'https://nordstrom.okta.com/oauth2/ausrdwx3dNoMaKaF32p6',
    redirectUri: 'https://nordsso.nordstrom.com/implicit/callback',
    scope: 'openid profile',
  },
  resourceServer: {
    messagesUrl: 'http://localhost:8000/api/messages',
  },
};



// WEBPACK FOOTER //
// ./src/.config.js